import { produce } from 'immer';

import {
	GetCaptchaOutputDto,
	GetDocumentsOutputDto,
	InitOutputDto,
	VoidDtoGenericValueDto,
	SimulationOutputDto,
	SimulationOverviewOutputDto,
	GenerateQrCodeOutputDto,
	DocumentType,
} from '@api/consumerloans-public-api';

import { CurrentPdf } from '../../hooks/usePdfViewer';
// import { AuthorizeResult, GetCustomerPersonalDataResult } from '@api/consumerloans-public-api';
import { StoreHelper } from '../storeHelper';

export interface ServicesState {
	init?: InitOutputDto;
	getCaptcha?: GetCaptchaOutputDto;
	sendMessage?: VoidDtoGenericValueDto;
	getDocuments?: GetDocumentsOutputDto;
	simulation?: SimulationOutputDto;
	simulationOverview?: SimulationOverviewOutputDto;
	qrCodeToApp?: string | null;
	linkToApp?: string | null;
	currentPdf?: CurrentPdf;
}

export const servicesInitialState: ServicesState = {};

interface UseServicesStoreOutput extends ServicesState {
	saveServiceResponse: (data: ServicesState) => void;
}

export const useServicesStore = StoreHelper.createStore<UseServicesStoreOutput>(
	(set) => ({
		...servicesInitialState,
		saveServiceResponse: (data: ServicesState) =>
			set(
				produce((state: ServicesState) => ({ ...data })),
				false,
				'saveServiceResponse'
			),
	}),
	'Services'
);
